/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3eea4f8a790f55db0c7616a20d78df87971679a5";
